const PageRoutes = {
    ROOT: "/",
    CHAPTER_ONE: "/chapter-one",
    CHAPTER_TWO: "/chapter-two",
    IMPORTANT_CONCEPTS: "/important-concepts",
    COMMODITY: "/commodity/:id",
    COMMODITY_ROOT: "/commodity/",
}

export default PageRoutes;